<template>
  <v-ons-list-item modifier="longdivider">
    <div class="left">
      <img
        :src="image"
        width="88px"
        class="image-thumb"
      >
    </div>
    <div class="center">
      <section class="destination-outline">
        <h1 class="destination-outline-title">{{ thing.item.name }}</h1>
        <p>{{ areaName }}</p>
      </section>
    </div>
  </v-ons-list-item>
</template>

<script>
const noImage = require('@/assets/images/noimage.svg');

export default {
  props: {
    thing: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    isFloorIdExisted: ({ thing }) => thing.item.floors != null && thing.item.floors.length > 0,
    floorId: ({ thing, isFloorIdExisted }) => (isFloorIdExisted ? thing.item.floors[0].id : null),
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    areaName: (vm) => (vm.isFloorIdExisted ? this.$store.getters['area/buildingAndFloorNameByFloorId'](vm.floorId) : '不明'),
    image: ({ thing }) => (thing.image && thing.image.url ? thing.image.url : noImage),
  },
};
</script>



// WEBPACK FOOTER //
// item.vue?1b594d05